import { render, staticRenderFns } from "./ToolHelp.vue?vue&type=template&id=05cd6a49&scoped=true"
import script from "./ToolHelp.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolHelp.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ToolHelp.vue?vue&type=style&index=0&id=05cd6a49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cd6a49",
  null
  
)

export default component.exports